import React from 'react'
import clsx from 'clsx'
import { format as dateFormat } from 'date-fns'

import { EmailType } from '@SonarCX/slices/extensionAPI'

import Button from '@SonarCX/components/atoms/Button2'

import { formatDateRelative } from '@SonarCX/utilities'
import useStyles from './styles'

export type TimelineEmailType = EmailType & {
  stamp: Date
  id: string
}

type TimelineEmailProps = {
  email: TimelineEmailType
  className?: string
  emailRootClass?: string
}

const TimelineEmail: React.FC<TimelineEmailProps> = ({
  email,
  className,
  emailRootClass
}) => {
  const [showBody, setShowBody] = React.useState(false)

  const time = React.useMemo(() => {
    const stamp = email.stamp
    const hours = dateFormat(stamp, 'h:mm aaa')
    const relativeDay = formatDateRelative(stamp, true)
    return `${hours}, ${relativeDay}`
  }, [email])

  const classes = useStyles()

  return (
    <div id={`email-${email.id}`} className={clsx(classes.root, className)}>
      <div className={clsx(classes.emailRoot, emailRootClass)}>
        <div className={classes.subjectBlock}>
          <div className={classes.subject}>
            <span className='emphasize'>Subject:</span>

            {email.subject}
          </div>

          <div className={classes.time}>{time}</div>
        </div>

        <div className={classes.sender}>
          <span className='emphasize'>From:</span>

          {email.sender}
        </div>

        <div className={classes.receiver}>
          <span className='emphasize'>To:</span>

          {email.recipient}
        </div>

        <div className={classes.body}>
          <Button onClick={() => setShowBody(old => !old)}>
            {showBody ? 'Hide' : 'Show'} Email
          </Button>

          {showBody && (
            <div
              dangerouslySetInnerHTML={{ __html: email.body }}
              style={{ color: 'initial' }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default TimelineEmail
